import _ from 'lodash';
import domains from '../containers/Domains';
import contextMakePost from './Context';
import {getLocalStorageDataOrFetch} from './fbCallManager';

const endpoint = domains.fbEndpoint;

export const createCanvasProductSet = async (data, token) => {
  const parameters = {
    access_token: token,
    canvas_product_set: data.canvas_product_set
  };

  const id = data.id;
  const result = await contextMakePost(parameters, id);
  return result.json();
};

export const getCanvasProductSet = async (id, token) => {
  const parameters = {
    access_token: token,
    id,
    fields: 'id,name,product_set_id'
  };

  const query = _.template(
    `${endpoint}<%= id%>?&fields=<%= fields%>&access_token=<%= access_token%>`
  );
  
  const jsonResult = await getLocalStorageDataOrFetch(query(parameters))
  
  return jsonResult;
};

export const getProductSet = async (id, token) => {
  const parameters = {
    access_token: token,
    id,
    fields: 'id,name,product_catalog,vehicles{dealer_name}'
  };

  const query = _.template(
    `${endpoint}<%= id%>?&fields=<%= fields%>&access_token=<%= access_token%>`
  );

  let jsonResult = await getLocalStorageDataOrFetch(query(parameters))

  // some product sets do not have vehicles connected, resulting in errors
  // alter the query to not use vehicles and run again
  const {error} = jsonResult || {};
  if(error){
    parameters.fields = 'id,name,product_catalog';
    jsonResult = await getLocalStorageDataOrFetch(query(parameters))
  }
  return jsonResult;
};


// WEBPACK FOOTER //
// ./src/fbApi/ProductSet.js